import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { reducer } from './_store/reducers';
import { HeaderEffects } from './_store/effects';
import { HeaderFacade } from './facade';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('header', reducer),
    EffectsModule.forFeature([HeaderEffects]),
    HttpClientModule
  ],
  providers: [HeaderFacade]
})
export class HeaderDataAccessModule {}
